import { memo } from "react";
import { Link } from "react-router-dom";
import { Image, type ComponentMarginProps } from "react-better-html";
import styled from "styled-components";

const LinkStyledComponent = styled(Link).withConfig({
   shouldForwardProp: (prop) => !["additionalStyle"].includes(prop),
})<{ additionalStyle?: object }>`
   display: block;
   width: fit-content;

   ${(props) => props.additionalStyle as any}
`;

type AppLogoProps = {
   /** @default "/" */
   href?: string;
   /** @default "light" */
   mode?: "light" | "dark";
} & ComponentMarginProps;

function AppLogo({ href = "/", mode = "light", ...props }: AppLogoProps) {
   return (
      <LinkStyledComponent to={href} additionalStyle={props}>
         <Image name={mode === "light" ? "logo" : "logoWhite"} width={100} />
      </LinkStyledComponent>
   );
}

export default memo(AppLogo);
